module.exports = __webpack_public_path__ + "static/media/bg-4.3c26e11c.jpeg";